<template>
<div class="scene" data-1500="top: 100%;" data-2500="top: 0%; " data-3100="top: 0%; " data-4100="top: -100%; display: block;" data-4101="top: -100%; display: none;" style="top: 0%;display: block">
    <div class="section2">
        <div class="section2-inner">
            <img class="twostoneleft" src="static/fog/section2/2-stoneleft.png" data-2000="left: -100%; display: block;" data-2500="left: 0%; display: block;" style="left: -100%; display: block;">
            <img class="twostoneright" src="static/fog/section2/2-stoneright.png" data-2000="right: -100%; display: block;" data-2500="right: 3%; display: block;" style="right: -100%; display: block;">
            <div>
                <img class="twoboard" src="static/fog/section2/2-board.png" data-2500="left: 5%; display: block;" style="left: -100%; display: none;">
                <div class="twotext" data-2500="left: -100%; display: block;" data-3100="left: 15%; display: block;" style="left: 15%; display: block;">
                    <div v-if="step === 1" >
                        <p class="twotext1" style="left: 16%; display: block;"><highlight>「情緒勒索」</highlight>到底是什麼呢？<br>近年越來越多人把這個詞掛在嘴邊，但你真<br>的知道情緒勒索的定義嗎？</p>
                        <img class="twoarrownext" src="static/fog/section2/arrownext.png" @click.prevent="next()" style="left: 55%; display: block;">
                    </div>
                    <div v-if="step === 2">
                        <p class="twotext2" style="left: 16%; display: block;">這個詞最初由<highlight>蘇珊.福沃德(Susan Forward)</highlight><br>這位心理治療家提出，意指一種<highlight>無法為</highlight>自己<br>的負面情緒負責，並企圖以<highlight>威脅、利誘</highlight>的方<br>式來<highlight>迫使他人順從</highlight>的行為模式。</p>
                        <img class="twoarrowpre" src="static/fog/section2/arrowpre.png" @click.prevent="prev()" style="left: 17%;display: block;">
                        <img class="twoarrownext" src="static/fog/section2/arrownext.png" @click.prevent="next()" style="left: 55%;display: block;">
                    </div>
                    <div v-if="step === 3">
                        <p class="twotext3" style="left: 16%; display: block;">情緒勒索是<highlight>宰制行動</highlight>中最有利的形式，所有<br>勒索的中心就是基本的<highlight>威脅恐嚇</highlight>，只是它會<br>以許多不同的面貌出現。</p>
                        <img class="twoarrowpre" src="static/fog/section2/arrowpre.png" @click.prevent="prev()" style="left: 17%;display: block;">
                        <img class="twoarrownext" src="static/fog/section2/arrownext.png" @click.prevent="next()" style="left: 55%;display: block;">
                    </div>
                    <div v-if="step === 4">
                        <p class="twotext4" style="left: 16%; display: block;">情緒勒索之所以能擊中我們內心的要害，是<br>因為勒索者非常瞭解我們「珍惜與他們之間<br>的關係」，以及抓住了我們的「弱點」。因<br>此他們會<highlight>利用親密關係</highlight>迫使我們讓步。</p>
                        <img class="twoarrowpre" src="static/fog/section2/arrowpre.png" @click.prevent="prev()" style="left: 17%;display: block;">
                        <img class="twoarrownext" src="static/fog/section2/arrownext.png" @click.prevent="next()" style="left: 55%;display: block;">
                    </div>
                    <div v-if="step === 5">
                        <p class="twotext5" style="left: 20%; display: block;">快來跟著迷 ‧ 麋一探情緒勒索的內幕！</p>
                        <img class="twoarrowpre" src="static/fog/section2/arrowpre.png" @click.prevent="prev()" style="left: 17%;display: block;">
                    </div>
                </div>
            </div>
            <img class="twograss" src="static/fog/section2/2-grass.png" data-2000="bottom: -100%; display: block;" data-2500="bottom: 15%; display: block;"  style="bottom: -100%; display: none;">
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            step:1,
        }
    },
    methods:{
        prev() {
            this.step--;
        },
        next() {
            this.step++;
        }
    }
}
</script>

<style>
@keyframes scale{
    0%{
        transform: scale(1)
    }
    50%{
        transform: scale(1.2) 
    }
    100%{
        transform: scale(1)
    }
}
.section2{
    height: 100%;
    background: #31664A;
}

.section2-inner{
    width: 1000px;
    height: 100%;
    margin: 0 auto;
    position: relative;
}
.twoboard{
    height: 75%;
    top: 10%;
}
.twograss{
    height: 10%;
    left: 10%;
}
.twostoneleft{
    height: 5%;
    top: 70%;
}
.twostoneright{
    height: 5%;
    top: 40%;
}
.twotext1,.twotext2,.twotext3,.twotext4,.twotext5{
    font-size: 25px;
    position: absolute;
    text-align: center;
}
.twotext1{
    top: 30%;
    color: #ddd;
}
.twotext2{
    height: 30%;
    top: 29%;
    color: #ddd;
}
.twotext3{
    height: 30%;
    top: 30%;
    color: #ddd;
}
.twotext4{
    height: 30%;
    top: 29%;
    color: #ddd;
}
.twotext5{
    height: 10%;
    top: 35%;
    color: #ddd;
}
.twoarrowpre{
    height: 6%;
    top: 58%;
    cursor: pointer;
    animation: scale 2s infinite;
}
.twoarrownext{
    height: 6%;
    top: 58%;
    cursor: pointer;
    animation: scale 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/fog/Section2.vue